<template>
  <div>
    <v-text-field
      v-model="formattedValue"
      :label="label"
      v-bind="$attrs"
      :clearable="Boolean(formattedValue)"
      :suffix="suffix"
      @keypress="numbersOnly"
      @paste="handlePaste"
      @keydown.ctrl.86="allowPaste"
      @keydown.ctrl.67="allowCopy"
    />
  </div>
</template>

<script>
import { numbersOnly } from '@/modules/_global/utils/events';
import {
  clearNumber,
  formatNumberByApostrophe
} from '@/modules/_global/filters';
export default {
  filters: { formatNumberByApostrophe, clearNumber },

  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    label: {
      type: String,
      default: 'Price'
    },
    suffix: {
      type: String,
      default: 'CHF'
    }
  },
  data() {
    return {
      modelValue: this.value
    };
  },
  computed: {
    formattedValue: {
      get() {
        return formatNumberByApostrophe(this.modelValue);
      },
      set(value) {
        this.modelValue = clearNumber(value);
        this.$emit('input', this.modelValue);
      }
    }
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler: 'setValue'
    }
  },
  methods: {
    numbersOnly,

    setValue() {
      this.modelValue = this.value;
    },

    handlePaste(event) {
      this.formattedValue = event.clipboardData.getData('text');
      event.preventDefault();
    },
    allowPaste(event) {
      event.stopPropagation();
    },
    allowCopy(event) {
      event.stopPropagation();
    }
  }
};
</script>
